"use client"

import clsx from "clsx"
import { useCartState } from "src/checkout/hooks/useCart"
import { freeShippingThreshold } from "src/data/feeds/shipping"
import { formatPriceLong } from "src/utilities/price"

export const NpFreeShippingProgress = () => {
  const { data: cart } = useCartState()

  const total = +(cart?.totals.total_price || 0) / 100
  const freeShippingRatio = total / freeShippingThreshold
  const shippingIsFree = freeShippingRatio >= 1
  const remaining = freeShippingThreshold - total

  return (
    <div className="flex flex-col gap-4 px-6">
      <div className="bg-np-gray25 rounded-full">
        <div
          style={{ width: `${Math.min(freeShippingRatio, 1) * 100}%` }}
          className={clsx("h-2 rounded-full", {
            "bg-np-green": shippingIsFree,
            "bg-np-black": !shippingIsFree,
          })}
        />
      </div>

      <div>
        {shippingIsFree ? "Glückwunsch," : `Noch ${formatPriceLong(remaining)} und`} du bekommst den Versand innerhalb
        Deutschlands kostenlos.
      </div>
    </div>
  )
}
